import { Stack, Text, HStack } from "@chakra-ui/react";
import Icon from "@modules/Icon";
import { Link } from "@chakra-ui/react";
import React, { memo } from "react";

const scheduleEvent = process.env.GATSBY_CALENDLY || "";

const FACEBOOK_PAGE =
  process.env.GATSBY_FACEBOOK ||
  "https://www.facebook.com/people/Communication-Devices-Inc/61552218295441/";
const TWITTER_PAGE =
  process.env.GATSBY_TWITTER || "https://twitter.com/CommsDevices23/";
const LINKEDIN_PAGE =
  process.env.GATSBY_LINKEDIN ||
  "https://www.linkedin.com/company/communication-devices-inc-/";
const YOUTUBE_PAGE =
  process.env.GATSBY_YOUTUBE ||
  "https://www.youtube.com/@CommunicationDevicesInc./";

const SocialNetwork = () => {
  return (
    <Stack>
      <Text textStyle={"h4"}>Connect with us</Text>
      <HStack pt={4} pb={8}>
        <Stack pr={10}>
          <Link
            href={FACEBOOK_PAGE}
            title="Commdevices Facebook Page"
            isExternal
          >
            <Icon name={"facebook"} />
          </Link>
        </Stack>

        <Stack pr={10}>
          <Link href={TWITTER_PAGE} title="Commdevices Twitter Page" isExternal>
            <Icon name={"twitter"} />
          </Link>
        </Stack>

        <Stack pr={10}>
          <Link
            href={YOUTUBE_PAGE}
            title="Commdevices Youtube Channel"
            isExternal
          >
            <Icon name={"youtube"} />
          </Link>
        </Stack>
        <Stack pr={10}>
          <Link href={LINKEDIN_PAGE} title="Commdevices Linkedin" isExternal>
            <Icon name={"linkedin"} />
          </Link>
        </Stack>
      </HStack>
    </Stack>
  );
};

export default memo(SocialNetwork);
